<template>
    <!-- <div class="wf-form">
        <div class="wf-form-item" v-for="(formItem, formKey) in renderList" :key="formKey">
            <label class="wf-form-item-label" :for="`wf-form-item-${formItem.key}`">{{formItem.label}}</label>
            <div class="wf-form-item-content">
                <Input v-if="formItem.type === 'input' || formItem.type === 'textarea'" :type="formItem.type === 'input' ? 'text' : formItem.type" v-model.trim="formDataComponent[formItem.key]" @on-change="handleChange($event, formItem)" @on-enter="handleEnter" :placeholder="formItem.placeholder"></Input>

                <Select v-model="formDataComponent[formItem.key]" v-if="formItem.type === 'select'" :placeholder="formItem.placeholder" @on-change="handleChange($event, formItem)"></Select>
            </div>
        </div>
    </div> -->
    <div class="wf-form">
        <div class="wf-form-pc">
            <Form ref="wf-form" :key="formKey" :model="formDataComponent" :rules="rules" :label-width="labelWidth">
                <FormItem :class="`${formItem.isHide ? 'wf-form-item-hide' : ''}`" v-for="(formItem, formKey) in renderList" :key="formKey" :label="formItem.label" :prop="formItem.key">
                    <template #label v-if="formItem.tipIcon">
                        <!-- <span class="wf-form-item-require" v-if="formItem.require">*</span> -->
                        {{formItem.label}}
                        <Poptip trigger="hover" :width="formItem.tipWidth">
                            <template #content>
                                <div class="wf-form-item-tip">
                                    <div class="wf-form-item-tip-top">{{formItem.tipTopText}}</div>
                                    <div v-for="(tipItem, tipKey) in formItem.tipList" :key="tipKey">
                                        <span>{{tipItem.text}}</span>
                                        <a target="_blank" :href="tipItem.link">{{tipItem.link}}</a>
                                    </div>
                                    <div class="wf-form-item-tip-bottom">{{formItem.tipBottomText}}</div>
                                </div>
                            </template>
                            <img class="wf-form-item-img" :src="formItem.tipIcon" alt="">
                        </Poptip>
                    </template>
                    <Input v-if="(formItem.type === 'input' || formItem.type === 'textarea')" :type="formItem.type === 'input' ? 'text' : formItem.type" :disabled="formItem.disabled" :readonly="formItem.readonly" :maxlength="formItem.maxLength" v-model="formDataComponent[formItem.key]" @on-blur="handleBlur(formItem)" :placeholder="formItem.placeholder" @on-change="handleChange($event, formItem)"></Input>

                    <Select v-if="formItem.type === 'select'" :disabled="formItem.disabled" v-model="formDataComponent[formItem.key]" :placeholder="formItem.placeholder" @on-change="handleChange($event, formItem)">
                        <Option v-for="(optionItem, optionKey) in formItem.options" :key="optionKey" :value="optionItem.value">{{optionItem.label}}</Option>
                    </Select>

                </FormItem>
            </Form>
        </div>

        <div class="wf-form-mobile">
            <Form ref="wf-form" label-position="top" :key="formKey" :model="formDataComponent" :rules="rules">
                <FormItem :class="`${formItem.isHide ? 'wf-form-item-hide' : ''}`" v-for="(formItem, formKey) in renderList" :key="formKey" :label="formItem.label" :prop="formItem.key">
                    <template #label v-if="formItem.tipIcon">
                        <!-- <span class="wf-form-item-require" v-if="formItem.require">*</span> -->
                        {{formItem.label}}
                        <Poptip trigger="hover" :width="formItem.tipWidth">
                            <template #content>
                                <div class="wf-form-item-tip">
                                    <div class="wf-form-item-tip-top">{{formItem.tipTopText}}</div>
                                    <div v-for="(tipItem, tipKey) in formItem.tipList" :key="tipKey">
                                        <span>{{tipItem.text}}</span>
                                        <a target="_blank" :href="tipItem.link">{{tipItem.link}}</a>
                                    </div>
                                    <div class="wf-form-item-tip-bottom">{{formItem.tipBottomText}}</div>
                                </div>
                            </template>
                            <img class="wf-form-item-img" :src="formItem.tipIcon" alt="">
                        </Poptip>
                    </template>
                    <Input v-if="(formItem.type === 'input' || formItem.type === 'textarea')" :type="formItem.type === 'input' ? 'text' : formItem.type" :disabled="formItem.disabled" :readonly="formItem.readonly" :maxlength="formItem.maxLength" v-model="formDataComponent[formItem.key]" @on-blur="handleBlur(formItem)" :placeholder="formItem.placeholder" @on-change="handleChange($event, formItem)"></Input>

                    <Select v-if="formItem.type === 'select'" :disabled="formItem.disabled" v-model="formDataComponent[formItem.key]" :placeholder="formItem.placeholder" @on-change="handleChange($event, formItem)">
                        <Option v-for="(optionItem, optionKey) in formItem.options" :key="optionKey" :value="optionItem.value">{{optionItem.label}}</Option>
                    </Select>

                </FormItem>
            </Form>
        </div>
    </div>

</template>

<script>
import Input from 'iview/src/components/input';
import Poptip from 'iview/src/components/poptip';
import Form from 'iview/src/components/form';
import FormItem from 'iview/src/components/form-item';
import Select from 'iview/src/components/select'
import Option from 'iview/src/components/option'
import { filterNum } from '../../utils/filters'
import { deepClone } from '../../utils/common'
export default {
    components: {
        Input,
        Select,
        Form,
        FormItem,
        Option,
        Poptip
    },
    data() {
        return {
            formDataComponent: {},
            formKey: Math.random(),
        }
    },
    props: {
        renderList: {
            type: Array,
            default: () => {
                return []
            }
        },
        formData: {
            type: Object,
            default: () => {
                return {}
            }
        },
        labelWidth: {
            type: Number,
            default: 80
        },
        rules: {
            type: Object,
            default: () => {
                return {}
            }
        },

    },
    model: {
        prop: 'formData',
        event: 'change'
    },
    mounted() {
        this.formDataComponent = { ...this.formData }
    },
    methods: {
        // 表单项数据改变时触发
        handleChange(event, formItem) {
            const formData = { ...this.formDataComponent }
            if (formItem.type === 'select') {
                formData[formItem.key] = event
            } else if (formItem.type === 'input' || formItem.type === 'textarea') {
                formData[formItem.key] = event.target.value
            }
            this.$emit('change', formData)
            this.$nextTick(() => {
                this.$emit('changeForm', {
                    formData: formData,
                    formItem: formItem
                })
            })
        },

        // 失去焦点事件
        handleBlur(formItem) {
            this.$emit('blur', formItem)
        },

        // 输入框回车事件
        handleEnter() {

        },

        setFormKey() {
            this.formKey = Math.random()
        }
    },
    watch: {
        formData: {
            handler(newValue) {
                this.formDataComponent = { ...newValue }
            }
        },
        rules: {
            handler(newValue) {
                this.formKey = Math.random()
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>
.wf-form {
    //
    @media screen and (min-width: 768px) {
        .wf-form-mobile {
            display: none;
        }
    }
    @media screen and (max-width: 768px) {
        .wf-form-pc {
            display: none;
        }
        /deep/ .ivu-form-item  {
            margin-bottom: 0.16rem;
        }
    }
    /deep/ .ivu-form {
        .ivu-form-item-label {
            padding-top: 0;
            padding-bottom: 0;
            line-height: 40px;
        }
        .ivu-input {
            padding: 0 16px;
            height: 40px;
        }

        textarea.ivu-input {
            padding: 8px 16px;
            height: 130px;
            font-size: 12px;
        }

        .ivu-select-input {
            padding: 0 16px;
            height: 38px;
        }
        .ivu-select-selection {
            height: 40px;
            .ivu-icon {
                right: 19px;
            }
        }

        .ivu-select-placeholder {
            padding-left: 16px;
            height: 38px;
            line-height: 38px;
        }

        .ivu-select-selected-value {
            padding-left: 16px;
            line-height: 38px;
        }
    }

    .wf-form-item-hide {
        display: none;
    }

    .wf-form-item-img {
        position: relative;
        width: 12px;
        height: 12px;
        margin-left: 5px;
        top: 2px;
    }
    .wf-form-item-tip {
        padding: 12px 4px;
        text-align: left;
        * {
            max-width: 360px;
            overflow: hidden;
            white-space: normal;
            word-break: break-all;
            text-align: left;
            font-size: 12px;
        }
    }

    .wf-form-item-require {
        display: inline-block;
        margin-right: 4px;
        line-height: 1;
        font-family: SimSun;
        font-size: 12px;
        color: #ed3f14;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/form/form.vue